// extracted by mini-css-extract-plugin
var _1 = "ListAdd_wrapper__01Vmd";
export { _1 as "wrapper" }
